module.exports = __webpack_public_path__ + "static/media/spinningDots.030c69d8.svg";